// extracted by mini-css-extract-plugin
export default {"container":"MdeIdCard_container__4UW-I"};